export default {
	"order.TheSystemIsOutOfOrder": "系统开小差啦",
	"order.AlipayScanCodeSigningContract": "支付宝扫码签约",
	"order.PayAndSignUp": "支付并签约",
	"order.GoToAlipayToSignAContract": "前往支付宝签约"
}